import React, { useEffect, useState } from 'react';
import PricingCard from '../../components/ui/PricingCard';
import ToggleButtonGroup from '../../components/ui/ToggleButtonGroup';
import { plans } from '../../data/plans_dummy';
import { plansTableDummy } from '../../data/plans_table_dummy';
import '../DashboardPages/extra.css';
import SpecialTable from '../../components/ui/SpecialTable';
import CreateAction from '../../components/operational/createAction';
import { useSelector } from 'react-redux';
import { license } from '../../data/license';
import PrimaryButton from '../../components/ui/PrimaryButton';

const header = [
  {
    icon: <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.4983 14.4808L20.6968 23.0945L19.4604 24L13.2632 15.387V19.5246H11.7368V15.387L5.53966 23.9999L4.30443 23.094L10.5016 14.4808L6.60386 15.7592L6.13188 14.2934L10.0297 13.015L0 9.72559L0.471989 8.25922L10.5023 11.5494L8.09295 8.20198L9.32511 7.29709L11.7368 10.6445V0H13.2632V10.6446L15.6749 7.29715L16.9101 8.20312L14.5008 11.5506L24.5281 8.25922L25 9.72496L14.9697 13.0158L18.8676 14.2941L18.3955 15.7598L14.4983 14.4808Z" fill="#6F66F6" />
    </svg>,

    subText: "Işık Hızında",
    text: "Native Mobil Uygulama"
  },
  {
    icon: <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.2273 4.85L18.5455 4.4C19.3468 3.39256 20.4641 2.6484 21.7389 2.27292C23.0138 1.89744 24.3816 1.90968 25.6487 2.3079C26.9158 2.70612 28.0179 3.47015 28.7988 4.49174C29.5798 5.51333 30 6.74071 30 8C30 9.25929 29.5798 10.4867 28.7988 11.5083C28.0179 12.5299 26.9158 13.2939 25.6487 13.6921C24.3816 14.0903 23.0138 14.1026 21.7389 13.7271C20.4641 13.3516 19.3468 12.6074 18.5455 11.6L13.4545 4.4C12.6532 3.39256 11.5359 2.6484 10.2611 2.27292C8.9862 1.89744 7.61835 1.90968 6.35128 2.3079C5.0842 2.70612 3.98213 3.47015 3.20119 4.49174C2.42024 5.51333 2 6.74071 2 8C2 9.25929 2.42024 10.4867 3.20119 11.5083C3.98213 12.5299 5.0842 13.2939 6.35128 13.6921C7.61835 14.0903 8.9862 14.1026 10.2611 13.7271C11.5359 13.3516 12.6532 12.6074 13.4545 11.6L13.8796 11" stroke="#6F66F6" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    subText: "Sınırsız",
    text: "İndirme ve Trafik"
  },
  {
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0V2C11.5822 1.99996 13.1288 2.46908 14.4444 3.34803C15.76 4.22698 16.7854 5.4763 17.391 6.938C17.7931 7.90877 18.0001 8.94924 18 10H20ZM0 8V3C0 2.73478 0.105357 2.48043 0.292893 2.29289C0.48043 2.10536 0.734784 2 1 2H6C6.26522 2 6.51957 2.10536 6.70711 2.29289C6.89464 2.48043 7 2.73478 7 3V7C7 7.26522 6.89464 7.51957 6.70711 7.70711C6.51957 7.89464 6.26522 8 6 8H4C4 10.1217 4.84285 12.1566 6.34315 13.6569C7.84344 15.1571 9.87827 16 12 16V14C12 13.7348 12.1054 13.4804 12.2929 13.2929C12.4804 13.1054 12.7348 13 13 13H17C17.2652 13 17.5196 13.1054 17.7071 13.2929C17.8946 13.4804 18 13.7348 18 14V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H12C5.373 20 0 14.627 0 8Z" fill="#6F66F6" />
    </svg>,
    subText: "7/24",
    text: "Telefon Desteği"
  },
]
const footerItems = [
  "Özel Yazılım Geliştirmeleri", "Özel Tasarım Geliştirmeleri", "Dedike Proje Yöneticisi", "Size Özel Entegrasyonlar", "Markanıza Özel Müşteri Temsilcisi", "İleri Seviye Pazarlama Araçları"
]
type Currency = '$' | '€' | '£' | '₺';

interface Plan {
  id: string
  licenseType: string;
  title: string;
  description: string;
  oldPrice: number | null;
  price: number;
  currency: Currency;
  features: string[];
  isPopular?: boolean;
  isPremium?: boolean;
  currencySymbol: string
}

const Plans = ({ onSelect }: { onSelect: Function }) => {
  const [selectedPlan, setSelectedPlan] = useState("");
  const [plans, setPlans] = useState<Plan[] | any[]>([])
  const activeLicense = useSelector((state: any) => state.myUserSlice?.license);
  const activeLicenseIndex = activeLicense?.order
  console.log(activeLicenseIndex, activeLicense)
  useEffect(() => {
    const getDefaultLicenses = async () => {
      const response = await CreateAction({
        method: 'get',
        path: `/defaultLicenses`,
        showPreLoader: true,
        isFileUploading: false,
        data: {}
      });

      if (response?.error || !response.result?.resultData) return
      setPlans(response.result?.resultData)
    }

    getDefaultLicenses()
  }, [])

  return (
    <div className="flex flex-1 flex-col p-[20px] overflow-y-auto">
      {/* <div className="mb-[40px] flex justify-center items-center">
        <ToggleButtonGroup buttons={['Aylık', 'Yıllık']} selected={selectedPeriod} setSelected={setSelectedPeriod} />
      </div> */}
      <div className="flex flex-col items-center justify-center gap-[32px] mb-[32px]">
        <div className="text-[40px] font-semibold text-[#3D3D3D]">İşletmenize En Uygun Planı Seçin</div>
        <div className="flex gap-[40px] flex-row items-center">
          {header?.map((headerItem) => {
            return <div className='flex flex-col gap-[2px] items-center'>
              {headerItem.icon}
              <div className='text-[16px] text-gray-500' > {headerItem.subText} </div>
              <div className='text-[16px] text-black' >{headerItem.text} </div>
            </div>
          })}
        </div>
      </div>
      <div className="flex gap-[20px]   duration-500 w-[100%]  ">
        {plans?.map((plan, index) => {
          return (
            <PricingCard
              key={plan.id}
              title={plan.title}
              description={plan.description}
              prices={{ oldPrice: plan.oldPrice, newPrice: plan.price, currency: plan.currency, monthlyPrice: plan.monthlyPrice, currencySymbol: plan.currencySymbol }}
              features={plan?.features?.features || []}
              selected={selectedPlan === plan.id}
              setSelected={() => { setSelectedPlan(plan.id); onSelect?.(plan) }}
              isPremium={plan.isPremium}
              isPopular={plan.isPopular}
              isDisabled={(license?.[plan.licenseType as keyof typeof license])?.order <= activeLicenseIndex}
            />
          )
        }
        )}
      </div>
      <div className="bg-gradient-to-r from-[#6f66f6] to-[#9993fc]  w-full text-white flex flex-row rounded-[15px] mt-[40px]">
        <div className='flex flex-col gap-[10px] p-[40px] shrink-0'>

          <div className='text-[24px] font-semibold'>Enterprise</div>
          <div className='flex flex-row items-center gap-[10px]'>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.77 9C10.83 8.505 10.875 8.01 10.875 7.5C10.875 6.99 10.83 6.495 10.77 6H13.305C13.425 6.48 13.5 6.9825 13.5 7.5C13.5 8.0175 13.425 8.52 13.305 9M9.4425 13.17C9.8925 12.3375 10.2375 11.4375 10.4775 10.5H12.69C11.9634 11.7512 10.8106 12.699 9.4425 13.17ZM9.255 9H5.745C5.67 8.505 5.625 8.01 5.625 7.5C5.625 6.99 5.67 6.4875 5.745 6H9.255C9.3225 6.4875 9.375 6.99 9.375 7.5C9.375 8.01 9.3225 8.505 9.255 9ZM7.5 13.47C6.8775 12.57 6.375 11.5725 6.0675 10.5H8.9325C8.625 11.5725 8.1225 12.57 7.5 13.47ZM4.5 4.5H2.31C3.02898 3.24528 4.18099 2.29593 5.55 1.83C5.1 2.6625 4.7625 3.5625 4.5 4.5ZM2.31 10.5H4.5C4.7625 11.4375 5.1 12.3375 5.55 13.17C4.1837 12.6992 3.03322 11.7511 2.31 10.5ZM1.695 9C1.575 8.52 1.5 8.0175 1.5 7.5C1.5 6.9825 1.575 6.48 1.695 6H4.23C4.17 6.495 4.125 6.99 4.125 7.5C4.125 8.01 4.17 8.505 4.23 9M7.5 1.5225C8.1225 2.4225 8.625 3.4275 8.9325 4.5H6.0675C6.375 3.4275 6.8775 2.4225 7.5 1.5225ZM12.69 4.5H10.4775C10.2424 3.57121 9.89484 2.67458 9.4425 1.83C10.8225 2.3025 11.97 3.255 12.69 4.5ZM7.5 0C3.3525 0 0 3.375 0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C2.89314 13.4997 3.71993 14.0522 4.62987 14.4291C5.53982 14.806 6.51509 15 7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 6.51509 14.806 5.53982 14.4291 4.62987C14.0522 3.71993 13.4997 2.89314 12.8033 2.1967C12.1069 1.50026 11.2801 0.947814 10.3701 0.570904C9.46018 0.193993 8.48491 0 7.5 0Z" fill="white" />
            </svg>
            <div className='text-[16px]'>Büyük İşletmeler İçin</div>
          </div>
        </div>
        <div className='h-full mt-[15px]'>

          <div className='h-[120px] w-[2px] rounded-full bg-white' ></div>

        </div>
        <div className='flex flex-col h-full justify-center m-auto px-[20px]'>
          <div className='flex flex-row flex-wrap  justify-center gap-[15px]'>

            {footerItems.map((footerItem) => {
              return (
                <div className='flex flex-row gap-[5px] text-[14px]'>
                  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 1.47204L5.65714 14L0 8.25802L1.45029 6.78598L5.65714 11.0455L16.5497 0L18 1.47204Z" fill="white" />
                  </svg>

                  {footerItem}
                </div>
              )
            })}
          </div>

        </div>

        <a
          className='my-auto h-[41px] flex shrink-0'
          href="mailto:admin@mobligo.com"
          onClick={(e) => {
            e.stopPropagation()
          }}>

          <PrimaryButton classes='!w-[243px] bg-white hover:bg-white !text-[#7059ef] my-auto mr-[40px] text-[14px] shrink-0 rounded-[8px]' value={"Sizi Arayalım"} />
        </a>

      </div>

    </div>
  );
};
export default Plans;


